import { useEffect, useMemo, useState } from 'react';
import { useQuery } from '@tanstack/react-query';

import { useIsFeatureEnabled, useIsLabFeatureEnabled } from '@/exceed';

import axios from '@/util/axios';

import getAxiosConfig from '../helpers/getAxiosConfig';

const useIsSourceMaterialProcessed = ({ objectiveableId, objectiveableType = 'Course' }) => {
  const [isProcessed, setIsProcessed] = useState(false);
  const sourceMaterialKey = useMemo(
    () => ['sourceMaterial', objectiveableId, objectiveableType],
    [objectiveableId, objectiveableType],
  );
  const aiContentEvaluators = useIsLabFeatureEnabled('content_evaluations');
  const aiContentGenerationBeta = useIsFeatureEnabled('ai_content_generation_beta');
  const isEnabled = aiContentEvaluators || aiContentGenerationBeta;

  const sourceMaterial = useQuery({
    queryKey: sourceMaterialKey,
    queryFn: async () =>
      (await axios(getAxiosConfig('get-source-material', { objectiveableId, objectiveableType })))
        .data,
    select: ({ data }) => data,
    refetchInterval: 3000,
    enabled: isEnabled && !isProcessed,
  });

  useEffect(() => {
    if (
      sourceMaterial?.isSuccess &&
      (!sourceMaterial?.data.length ||
        sourceMaterial?.data.every(({ status }) => status === 'success' || status === 'failure'))
    ) {
      setIsProcessed(true);
    }
  }, [sourceMaterial]);

  return !isEnabled || isProcessed;
};

export default useIsSourceMaterialProcessed;
